// extracted by mini-css-extract-plugin
export default {"legendGrid":"ResultType_legendGrid__5dZcJ"};